module.exports = __webpack_public_path__ + "src/assets/img/07_4art_3part.8f596284.jpg";